// extracted by mini-css-extract-plugin
export default {"leftLogo":"Hexagons_leftLogo__yPnZv","rightLogo":"Hexagons_rightLogo__PZmKx"};